export default function getActiveBlockKey(editorState) {
  const selection = editorState.getSelection();
  return selection.getStartKey();
}
